import { Grid, Stack, Title } from '@mantine/core'

import {
  Collection as CollectionType,
  Product as ProductType,
  Showcase as ShowcaseType,
  Site as SiteType,
  Store as StoreType
} from '@/types'

import ProductCard from './ProductCard'

interface Props {
  site?: SiteType
  store?: StoreType
  showcase?: ShowcaseType
  collections: CollectionType[]
  products: ProductType[]
}

export default function SinglePageCollectionsDisplay({
  site,
  store,
  showcase,
  collections,
  products
}: Props) {
  return (
    <Stack>
      {Array.isArray(collections) &&
        !!collections?.length &&
        collections?.map(collection => (
          <Stack mb="xl" key={collection.uid}>
            <Title>{collection.displayName}</Title>
            {Array.isArray(products) && !!products?.length && (
              <Grid gutter="lg">
                {products
                  .filter((product: any) => product.collection.uid === collection.uid)
                  .map((product: any) => (
                    <Grid.Col key={product?.uid} span={12} xs={6} md={4} lg={12 / 5}>
                      <ProductCard
                        product={product}
                        site={site}
                        store={store}
                        showcase={showcase}
                      />
                    </Grid.Col>
                  ))}
              </Grid>
            )}
          </Stack>
        ))}
    </Stack>
  )
}
